import React, { useState, useEffect } from "react";
import { Form, Popconfirm, Spin } from "antd";
import Button from "@/common/elements/Button";
import DataTable from "@/common/elements/DataTable";
import CustomModal from "@/components/CustomModal";
import { PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchStaffGroupById } from "@/apis/security/staffGroupsApi";
import {
  saveClientParam,
  deleteClientParam,
} from "@/apis/config/clientParamsApi";
import { clearCurrentParam } from "@/slices/clientParamsSlice";
import ClientParamsForm from "./StaffGroupForms/ClientParamsForms";
import {
  StyledFlex,
  StyledSectionHeading,
  StyledSubTableContainer,
} from "@/common/styles";
import useDialog from "@/hooks/useDialog";
import { fetchAllSecurityListOfStaff } from "@/apis/staff/staffApi";
import { setBookings } from "@/slices/bookingsSlice";
import { isNonEmptyVariable } from "@/util/common_function";
import { v4 as uuidV4 } from "uuid";
import _ from "lodash";
import useGridColumnConfig from "@/hooks/useGridColumnConfig";

const CLIENT_PARAMS_HEADERS = [
  { key: "paramName", text: "Param Name" },
  { key: "paramContext", text: "Param Context" },
  { key: "paramValue", text: "Param Value" },
];

// Stable reference: a fresh `{}` literal on every render re-fires the form's
// seed effect (deps: [initialValues]) and wipes in-progress Add input whenever
// this component re-renders (e.g. any redux dispatch re-renders the parent).
const EMPTY_INITIAL_VALUES = {};

const ClientParamsDetails = ({ staffGroupsId, headerSubTitle, disabled = false, bookingsFieldsEnabled, startingPoint = "" }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { showDialog } = useDialog();

  // Two different callers pass two different flags for the same thing, in
  // opposite senses: the Staffing/Users screen (PoliceCentralUserInfo.jsx)
  // passes bookingsFieldsEnabled (true = editable), the Security module's
  // Staff Groups screen (StaffGroupForms/index.jsx) passes disabled (true =
  // read-only) and never passes bookingsFieldsEnabled. Reconciling them into
  // one flag here is what lets this component behave correctly for both,
  // instead of the Add/Details/Delete buttons only ever reacting to
  // `disabled`, which is silently always its false default on the
  // Staffing/Users side (bookingsFieldsEnabled was accepted as a prop but
  // never actually read anywhere) - that's why Add/Delete stayed enabled
  // there regardless of whether the Staff record was in view or modify mode.
  const isEditable =
    bookingsFieldsEnabled !== undefined ? bookingsFieldsEnabled : !disabled;

  // "Config" — drag-reorder/resize columns, persisted per-user (see
  // docs/plans/grid-column-config-feature.md). Shared between the Staff
  // module's "Login Information" tab (startingPoint="Staff", legacy
  // ListID="ClientParams" in StaffInterfaceCommon.asp) and the Security
  // module's Staff Groups edit screen (startingPoint="Staff Groups",
  // legacy StaffGroupsInterface.asp — same ListID, different ModuleName).
  const {
    headers,
    isConfiguring,
    configButtonLabel,
    startConfiguring,
    confirmSave,
    discardChanges,
    dataTableRef: tableRef,
  } = useGridColumnConfig(
    `${startingPoint || "Staff Groups"}:ClientParams`,
    CLIENT_PARAMS_HEADERS
  );

  const [mode, setMode] = useState("add"); // "add" | "edit"
  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);

  // const parent = useSelector((s) => s.staffGroups.current);
  const listLoading = useSelector((s) => s.staffGroups.currentLoading);
  const [list, setList] = useState([])

  const current = useSelector((s) => s.clientParams.current);
  const currentLoading = useSelector((s) => s.clientParams.currentLoading);
  const saving = useSelector((s) => s.clientParams.saving);
  const deleting = useSelector((s) => s.clientParams.deleting);
  const { bookings } = useSelector((s) => s?.bookings);

  useEffect(() => {
    if (staffGroupsId != null) {
      // dispatch(fetchStaffGroupById(staffGroupsId));
      // dispatch(clearCurrentParam());
      setSelectedRow(null);
    }
  }, [dispatch]);

  useEffect(() => {
    if (isNonEmptyVariable(bookings?.clientParams)) {
      let allRules = bookings?.clientParams?.map((e, i) => {
        return {
          ...e,
          uuid: uuidV4(),
        }
      })
      console.log(allRules, "allRules")
      if (allRules?.length) {
        setList([...allRules])
      }
      else{
        setList([])
      }
    }
  }, [bookings]);

  const openAdd = () => {
    form.resetFields();
    dispatch(clearCurrentParam());
    setMode("add");
    setModalOpen(true);
  };

  // Single open path for a row, same as UserInfoRulesControllingAccess.jsx's
  // Details button/row-click - whether the record opens read-only or
  // editable is governed by isEditable (passed to the modal/form below), not
  // by which function opened it.
  const openEdit = () => {
    if (!selectedRow) return;
    setMode("edit");
    setModalOpen(true);
  };

  // open delete confirm
  const openDelete = () => {
    if (!selectedRow) return;
    showDialog("confirm", {
      title: "Are you sure you want to delete this record?",
      onConfirm: () => confirmDelete(),
    });
    // confirmDelete()
  };

  const confirmDelete = () => {
    dispatch(deleteClientParam(selectedRow.clientParamID))
    let newList = _.cloneDeep(list)
    if (newList?.length) {
      newList = newList.filter((e, i) => {
        if (e.uuid != selectedRow?.uuid) {
          return e
        }
      })
      // console.log({ newList })
      dispatch(
        setBookings({
          clientParams: [...newList],
        })
      );
    }
    setSelectedRow(null);
  };

  const handleSave = () => form.submit();

  const handleCloseModal = () => {
    setModalOpen(false);
    tableRef?.current?.resetAll();
  };

  const onFinish = (values) => {
    const payload = {
      ...values,
      staffId: bookings?.staffId,

    };
    // dispatch(saveClientParam(payload)).then(() => {
    //   if (bookings?.staffId)
    //     dispatch(fetchAllSecurityListOfStaff(bookings?.staffId))
    // }
    // );
    let newList = _.cloneDeep(list)
        // console.log({ payload })
        if (mode == "edit") {
          console.log({ selectedRow })
          if (newList?.length) {
            newList = newList.map((e, i) => {
              if (e.uuid == selectedRow?.uuid) {
                console.log({ ...e, ...payload }, "newList")
                return { ...e, ...payload }
              }
              return e
            })
            console.log({ newList })
          } 
        }
        // console.log({ newList })
    
        if (mode == "add") {
          if (newList?.length == 0) {
            newList.push(payload)
            // setList([payload])
          } else {
            console.log({payload})
            newList=[...newList,payload]
            // setList([...list, payload])
          }
        }
        // console.log({list})
        dispatch(
          setBookings({
            clientParams: [...newList],
          })
        );
    handleCloseModal();
  };

  // const list = useSelector((s) => s.staff.clientParams) || [];

  const onRowClick = (row, index) => {
    setSelectedRow(row);
    if(index !== null && index !== undefined) {
      openEdit();
    }
  };

  return (
    <>
      <StyledSectionHeading marginTop="20px">
        <span>Client Parameters</span>
      </StyledSectionHeading>

      <StyledSubTableContainer>
        <StyledFlex gap="10px" justify="space-between">
          <div>
            <h2>{headerSubTitle}</h2>
          </div>
          <StyledFlex gap="10px" marginBottom="8px" marginTop="0px">
            <Button
              onClick={openAdd}
              loading={saving}
              disabled={!isEditable || isConfiguring}
            >
              <PlusOutlined /> Add
            </Button>
            <Button
              onClick={openEdit}
              disabled={!selectedRow || isConfiguring}
              loading={currentLoading}
              style={{ marginLeft: 8 }}
            >
              Details
            </Button>
            <Button
              onClick={openDelete}
              disabled={!selectedRow || !isEditable || isConfiguring}
              loading={deleting}
              style={{ marginLeft: 8 }}
            >
              Delete
            </Button>

            {/* Config — drag-reorder/resize columns */}
            {!isConfiguring ? (
              <Button htmlType="button" onClick={startConfiguring} style={{ marginLeft: 8 }}>
                {configButtonLabel}
              </Button>
            ) : (
              <Popconfirm
                title="Save the current column layout?"
                onConfirm={confirmSave}
                onCancel={discardChanges}
                okText="Yes"
                cancelText="No"
              >
                <Button htmlType="button" style={{ marginLeft: 8 }}>{configButtonLabel}</Button>
              </Popconfirm>
            )}
          </StyledFlex>
        </StyledFlex>

        <Spin spinning={listLoading}>
          <DataTable
            ref={tableRef}
            headers={headers}
            draggable={isConfiguring}
            data={list||[]}
            rowUniqueId="uuid"
            onRowClick={onRowClick}
          />
        </Spin>
      </StyledSubTableContainer>

      {isModalOpen && (
        <CustomModal
          size="lg"
          header="Client Param"
          show={isModalOpen}
          onHide={handleCloseModal}
          onSaveClick={handleSave}
          confirmLoading={saving}
          backdrop={false}
          maskClosable={false}
          isDisabled={!isEditable}
        >
          <ClientParamsForm
            form={form}
            initialValues={mode === "edit" ? selectedRow : EMPTY_INITIAL_VALUES}
            onFinish={onFinish}
            disabled={currentLoading || !isEditable}
          />
        </CustomModal>
      )}
    </>
  );
};

ClientParamsDetails.defaultProps = {
  headerSubTitle: "List of Client Params for this Staff Group",
};

export default ClientParamsDetails;
